"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Rage+ API
 * API für das Rage+ / VerseNeo Backend der BLB Shops für Edelmetalle und Sorten
 *
 * The version of the OpenAPI document: 1.0.44
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
* Enum class ApplicationId.
* @enum {}
* @readonly
*/
var ApplicationId = exports.default = /*#__PURE__*/function () {
  function ApplicationId() {
    _classCallCheck(this, ApplicationId);
    /**
     * value: "VNeoEmBpBuy"
     * @const
     */
    _defineProperty(this, "VNeoEmBpBuy", "VNeoEmBpBuy");
    /**
     * value: "VNeoEmBpSell"
     * @const
     */
    _defineProperty(this, "VNeoEmBpSell", "VNeoEmBpSell");
    /**
     * value: "RageEmBpBuy"
     * @const
     */
    _defineProperty(this, "RageEmBpBuy", "RageEmBpBuy");
    /**
     * value: "RageEmBpSell"
     * @const
     */
    _defineProperty(this, "RageEmBpSell", "RageEmBpSell");
    /**
     * value: "RageSoBpBuy"
     * @const
     */
    _defineProperty(this, "RageSoBpBuy", "RageSoBpBuy");
    /**
     * value: "RageSoBpSell"
     * @const
     */
    _defineProperty(this, "RageSoBpSell", "RageSoBpSell");
  }
  return _createClass(ApplicationId, null, [{
    key: "constructFromObject",
    value:
    /**
    * Returns a <code>ApplicationId</code> enum value from a Javascript object name.
    * @param {Object} data The plain JavaScript object containing the name of the enum value.
    * @return {module:model/ApplicationId} The enum <code>ApplicationId</code> value.
    */
    function constructFromObject(object) {
      return object;
    }
  }]);
}();